import { Button, KIND, SHAPE, SIZE } from "baseui/button";
import { useState } from "react";
import { VscAdd } from "react-icons/vsc";
import { AddExceptionDialog } from "./AddExceptionDialog";
import { IScheduler } from "../../types";
import { ICalendar } from "../../../Calendar";

export const AddExceptionDialogButton = (props: { app: IScheduler, onAdd,calendarsFilter(calendar: ICalendar): boolean, }) => {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <>
            <Button  onClick={() => setIsOpen(true)} kind={KIND.primary} size={SIZE.default} shape={SHAPE.round} overrides={{
                BaseButton: {
                    style: ({ $theme }) => ({
                        boxShadow: $theme.lighting.shadow400,
                    })
                }
            }}
            >
                <VscAdd></VscAdd>
            </Button>
            { isOpen && <AddExceptionDialog calendarsFilter={props.calendarsFilter} app={props.app} isOpen={isOpen} setIsOpen={setIsOpen} onAdd={props.onAdd}></AddExceptionDialog>}
        </>
    )
};